export { default as SimpleSlide } from './SimpleSlide';
